import React from 'react';
import styles from './index.module.scss'
import Gallery from '../gallery';

const InnerContent = (props) => {
  const {compData} = props;

  return (
    <div className={styles.wrapper}>
      {/* <div className={styles.shortDescription} dangerouslySetInnerHTML={{ __html: compData[0]?.acf?.shortDescription }}></div> */}
        <div className={styles.innerWrapper}>
        <div dangerouslySetInnerHTML={{ __html: compData[0]?.content?.rendered }}></div>
        <Gallery compData={compData[0]?.acf}/>
        </div>
    </div>
  );
};

export default InnerContent;
